import {useTranslation} from "react-i18next";
import {navigate} from "../../app/router";
import {cabinetFixturesEnabled} from "./adapters";
import type {CabinetScenario} from "./model";

const scenarios = ["normal", "empty", "error", "loading", "long", "no_avatar", "multi_currency", "blocked"] as const;

export function scenarioFromSearch(search: string, key = "scenario"): CabinetScenario {
  const value = new URLSearchParams(search).get(key);
  return scenarios.find((scenario) => scenario === value) ?? "normal";
}

export function ScenarioPicker({pathname, search, parameter = "scenario", compact = false}: {pathname: string; search: string; parameter?: string; compact?: boolean}) {
  const {t} = useTranslation();
  if (!cabinetFixturesEnabled) return null;
  const current = scenarioFromSearch(search, parameter);
  const change = (value: CabinetScenario) => {
    const params = new URLSearchParams(search);
    if (value === "normal") params.delete(parameter);
    else params.set(parameter, value);
    const query = params.toString();
    navigate(`${pathname}${query ? `?${query}` : ""}`, true);
  };
  return <label className={compact ? "cabinet-scenario compact" : "cabinet-scenario"} data-cabinet-fixtures="review">
    <span>{t("cabinet.review.scenario")}</span>
    <select value={current} onChange={(event) => change(event.target.value as CabinetScenario)}>
      {scenarios.map((scenario) => <option key={scenario} value={scenario}>{t(`cabinet.review.scenarios.${scenario}`)}</option>)}
    </select>
  </label>;
}

export function OverviewReviewControls({pathname, search}: {pathname: string; search: string}) {
  const {t} = useTranslation();
  if (!cabinetFixturesEnabled) return null;
  return <section className="cabinet-review-panel" aria-label={t("cabinet.review.panelAria")} data-cabinet-fixtures="overview">
    <strong>{t("cabinet.review.panelTitle")}</strong>
    <div>{(["profile", "wallet", "orders", "dialogs"] as const).map((source) => <label key={source}>
      <span>{t(`cabinet.review.sources.${source}`)}</span>
      <select value={scenarioFromSearch(search, source)} onChange={(event) => {
        const params = new URLSearchParams(search);
        const value = event.target.value as CabinetScenario;
        if (value === "normal") params.delete(source);
        else params.set(source, value);
        const query = params.toString();
        navigate(`${pathname}${query ? `?${query}` : ""}`, true);
      }}>
        {scenarios.slice(0, 4).map((scenario) => <option key={scenario} value={scenario}>{t(`cabinet.review.scenarios.${scenario}`)}</option>)}
      </select>
    </label>)}</div>
  </section>;
}
